import * as api from "./api";
import * as actionTypes from "./actionTypes";

const update = (items) => ({
  type: actionTypes.UPDATE,
  items,
});

export const append = (item) => ({
  type: actionTypes.APPEND,
  item
});

export const updateOne = (item) => ({
  type: actionTypes.UPDATE_ONE,
  item,
});

export const destroy = (item) => ({
  type: actionTypes.DESTROY,
  item,
});

const loading = () => ({
  type: actionTypes.LOADING
});

export const remove = (item) => (dispatch) =>
         api.remove(item._id).then((r) => dispatch(destroy(r)));

export const findItems = params => dispatch => {
  dispatch(loading());
  return api
    .find(params)
    .then((r) => dispatch(update(r.data)))
    .catch((err) => {
      console.log('Error', err);
      throw(err);
    });
}

export const create = payload => dispatch => {
  return api
    .create(payload)
    .then((r) => dispatch(append(r)))
    .catch((err) => {
      console.log("Error", err);
      throw err;
    });
}

export const patch = (item, payload) => (dispatch) =>
         api.patch(item._id, payload).then((r) => dispatch(updateOne(r))).catch((err) => {
      console.log("Error", err);
      throw err;
    });